// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"1":"dbc99fd3863e8a9e1fe0","96":"b17df4f390327af492d3"}[chunkId] + ".js");